/* import __COLOCATED_TEMPLATE__ from './leave-modal.hbs.js'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
## Setup Guide/Leave Modal

When a merchant attempts to leave the Setup Guide during a walkthrough, this modal pops up to confirm the merchant meant to leave the Setup Guide.

### Example Usage

```javascript
{
 modal: Ember.inject.service(),
 actions: {
  openModal() {
    this.get('modal').open('setup-guide/leave-modal');
  }
}
```

Sass dependencies at: `lib/01-dashboard-shared/addon/styles/dashboard/components/setup-guide/_modal.scss`
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  setupGuide: service(),
  tracking: service('setup-guide/tracking'),
  walkthrough: service(),
  actions: {
    leave() {
      if (this.walkthrough.currentWalkthrough) {
        const progress = this.walkthrough.currentWalkthrough.isComplete ? 'After Complete' : 'In Task';
        this.walkthrough.stop();
        this.close();
        this.tracking.trackExitSetupGuide(progress, this.setupGuide.currentActionItemName);
      } else {
        this.close();
      }
    },
    stayHere() {
      this.close();
    }
  }
});